<template>
  <footer class="footer bg-primary text-white">
    <nav class="navbar">
      <div class="container">
        <div class="row d-flex justify-content-center mx-auto text-center">
          <div>
            <p class="text-success mt-5 mb-1 pb-1">本網站僅供個人作品使用，不提供商業用途 <span class="d-none d-md-inline">|</span>
              <span class="d-none d-md-inline-block"><router-link to="/admin/products" class=" login" target="_blank">登入管理後台</router-link></span>
            </p>
        <p class="text-success mt-1 fs-6">MOMENT © 2022 COPYRIGHT</p>
        <p class="mt-3">
          <a href="https://github.com/popeye-ux" target="_blank" class="text-success px-2"><i class="bi bi-github"></i> </a>
          <a href="mailto:popeye.ux@gmail.com" target="_blank" class="text-success px-2"><i class="bi bi-envelope"></i></a>
        </p>
          </div>
        </div>
      </div>
    </nav>
  </footer>
</template>
